import React from 'react';
import { Input, Button, Transition, Grid, Sticky } from 'semantic-ui-react';
import Image from '../../../atoms/Image';
import closebtnImg from '../assets/closebtn.png';
import closebtnDarkImg from '../assets/closebtnDark.png';
import NoFormInputs from '../components/NoFormInputs';

const Banner = props => {
  const {
    description,
    bgColor,
    descriptionTextColor,
    button,
    submitForm,
    closeEmailCapture,
    isVisible,
    isSubmitting,
    isSuccess,
    updateFormFields,
    fields,
    formFieldValues,
    errors,
    darkCloseBtn,
  } = props;
  const { key: inputKey, label } = fields[0]; // Banner only uses first field
  const value = formFieldValues[inputKey] || '';
  const errorMsg = errors[inputKey];

  return (
    <Transition visible={isVisible} animation="slide down" unmountOnHide>
      <Sticky active>
        <Grid
          style={{ backgroundColor: bgColor }}
          verticalAlign="middle"
          className="emailcapture-banner"
        >
          <Grid.Column computer="2" tablet="1" only="computer tablet" />
          <Grid.Column
            computer="12"
            tablet="13"
            only="computer tablet"
            className="emailcapture-banner-col"
          >
            <span style={{ color: descriptionTextColor }}>{description}</span>

            {isSuccess && <NoFormInputs />}
            {!isSuccess && (
              <>
                <div>
                  {errorMsg && (
                    <p
                      className="emailcapture-form-input-error"
                      style={{ color: descriptionTextColor }}
                    >
                      {errorMsg}
                    </p>
                  )}
                  <Input
                    error={errorMsg}
                    placeholder={label}
                    onChange={event => updateFormFields(inputKey, event)}
                    value={value}
                  />
                </div>
                <Button
                  loading={isSubmitting}
                  onClick={submitForm}
                  style={{ backgroundColor: button.bgColor, color: button.textColor }}
                >
                  {button.label}
                </Button>
              </>
            )}
          </Grid.Column>
          <Grid.Column
            computer="2"
            tablet="2"
            only="computer tablet"
            className="emailcapture-banner-close"
          >
            <Image
              as="a"
              src={darkCloseBtn ? closebtnDarkImg : closebtnImg}
              onClick={closeEmailCapture}
            />
          </Grid.Column>

          <Grid.Column mobile="13" only="mobile" className="emailcapture-banner-col">
            <span style={{ color: descriptionTextColor, textAlign: 'center' }}>{description}</span>
          </Grid.Column>
          <Grid.Column mobile="3" only="mobile" className="emailcapture-banner-close">
            <Image
              as="a"
              src={darkCloseBtn ? closebtnDarkImg : closebtnImg}
              onClick={closeEmailCapture}
            />
          </Grid.Column>
          <Grid.Column mobile="16" only="mobile" className="emailcapture-banner-col">
            <Input
              placeholder={label}
              onChange={event => updateFormFields(inputKey, event)}
              value={value}
            />
            <Button
              loading={isSubmitting}
              onClick={submitForm}
              style={{ backgroundColor: button.bgColor, color: button.textColor }}
            >
              {button.label}
            </Button>
          </Grid.Column>
        </Grid>
      </Sticky>
    </Transition>
  );
};

export default Banner;
